import React,{useState,useEffect,useRef, useContext} from 'react';
import {Container,Row,Col,Form} from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import '../../pages/Dashboard/dashboard.css';
import { BoxVentas,BoxMetas, TablaAgentes, TablaFlotillas,GraficaPeriodo,CarteraIndividual, CarteraFlotillas, SegmentacionCartera, SegmentacionCarteraOficina, CarteraIndividualOficina, CarteraFlotillasOficina, TablaAgentesGrupo, TablaAgentesPromotoria, GraficaPeriodoPromotoria } from '../../Components/Components';
import { Link, useHistory,useRouteMatch,useParams} from "react-router-dom";
import { IconBack } from '../../Components/Icons';
import { AuthContext } from '../../auth/AuthContext';
import { SelectAgente, SelectTypeAgente } from '../../Components/SelectGroup/SelectGroup';

export const ViewPromotoria = ({initState,updateState}) => {

  // GET ID FROM PARAMS
  const {id} = useParams();
  const history = useHistory();
  const {usuario} = useContext(AuthContext)

  const ref = useRef(null);
  const currentYear = new Date().getFullYear();
  const beforeYear = new Date(new Date().setFullYear(new Date().getFullYear() - 1)).getFullYear();

  const [dataPromotoria,setDataPromotoria] = useState([]);
  const {openMenu, data, loadingData,profileOficinas,profileOficinasAgentes,viewOficinaData} = initState;
  const [isSticky, setSticky] = useState(false);
  // const [loadDatagraficaTipo,setLoadDatagraficaTipo] = useState(false);
  const [loadSelect,setLoadSelect] = useState(false);
  const [loadDatagraficaTipo,setLoadDatagraficaTipo] = useState(false);
  const [loadDataAgentes,setLoadDataAgentes] = useState(false);
  const [loadSegmentacionCartera,setLoadSegmentacionCartera] = useState(false)
  const [loadCarteraIndividual,setLoadCarteraIndividual] = useState(false)
  const [loadCarteraFlotillas,setLoadCarteraFlotillas] = useState(false)

  const {
    ventasMonthCurrent         = [],
    ventasYearCurrent          = [],
    ventasYearBefore           = [],
    ventasLast12Months         = [],
    siniestralidadMonthCurrent = [],
    siniestralidaLast12Months  = [],
    nombre_promotoria          = "",
  } = dataPromotoria;

  const handleScroll = () => {
    const winScroll = document.body.scrollTop || document.documentElement.scrollTop
    const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    const scrolled = winScroll / height;
    scrolled>0 ? setSticky(true) : setSticky(false) 
  };

  //show shadow on sticky header select
  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', () => handleScroll);
    };
  }, [])

  useEffect(() => {
    updateState({
      loadingData: true
    })
    getProfilePromotoria()
  },[])


  return (
    <>
      <div className={`ws_content_wrapper ${(!openMenu) ? 'wrapper_close' : ''}`}>
        <div className="ws_content_header ws_pl_0 ws_pr_0 mb-5">
  
          <Container fluid className={`ws_header_fixed ${isSticky ? 'shadow' : ''} mt-st-7`} ref={ref} style={{borderBottom:'1px solid #ccc'}}>
            <Row>
              <Col className="mb-2" xs={12} md={3}>
                {
                  <span className="ws_title_header" style={{cursor:'pointer'}} onClick={ (e) => { history.goBack(); }} ><IconBack widht="20px" height="20px" className="pe-2" />{nombre_promotoria}</span>
                }
              </Col>
            </Row>
          </Container>

          <Container fluid className="mt-5">
            <Row>
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasMonthCurrent.color} title={ventasMonthCurrent.titulo} value={"$" + number_format(ventasMonthCurrent.valor, 2)} percent={ventasMonthCurrent.porcentaje} date={ventasMonthCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasYearBefore.color} title={ventasYearBefore.titulo} value={"$" + number_format(ventasYearBefore.valor, 2)} percent={ventasYearBefore.porcentaje} date={ventasYearBefore.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasYearCurrent.color} title={ventasYearCurrent.titulo} value={"$" + number_format(ventasYearCurrent.valor, 2)} percent={ventasYearCurrent.porcentaje} date={ventasYearCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={ventasLast12Months.color} title={ventasLast12Months.titulo} value={"$" + number_format(ventasLast12Months.valor, 2)} percent={ventasLast12Months.porcentaje} date={ventasLast12Months.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={siniestralidadMonthCurrent.color} title={siniestralidadMonthCurrent.titulo} value={siniestralidadMonthCurrent.valor + "%"} percent={siniestralidadMonthCurrent.porcentaje} date={siniestralidadMonthCurrent.subtitulo} />
              <BoxVentas state={initState} updateState={updateState} loading={loadingData} tagColor={siniestralidaLast12Months.color} title={siniestralidaLast12Months.titulo} value={siniestralidaLast12Months.valor + "%"} percent={siniestralidaLast12Months.porcentaje} date={siniestralidaLast12Months.subtitulo} />
            </Row>
            <Row>
              <GraficaPeriodoPromotoria 
              state={initState} 
              updateState={updateState} 
              year={currentYear} 
              selected={currentYear}  
              loadDatagraficaTipo={loadDatagraficaTipo}
              setLoadDataGraficaTipo={setLoadDatagraficaTipo}
              dataSelect={{
                promotor: id,
              }}
              size={{xs:12,sm:6,md:6,lg:6}} 
              />
              <GraficaPeriodoPromotoria 
              state={initState} 
              updateState={updateState} 
              year={currentYear} 
              selected={currentYear}  
              loadDatagraficaTipo={loadDatagraficaTipo}
              setLoadDataGraficaTipo={setLoadDatagraficaTipo}
              dataSelect={{
                promotor: id,
              }}
              size={{xs:12,sm:6,md:6,lg:6}} 
              />
              <TablaAgentesPromotoria
              initState={initState}
              updateState={updateState}
              loadDataAgentes={loadDataAgentes}
              setLoadDataAgentes={setLoadDataAgentes}
              dataSelect={{
                promotor  : id
              }}
              viewPromotoria={true}
              />
            </Row>
          </Container>
        </div>
      </div>
    </>
  )

  function getProfilePromotoria() {
    fetch(`https://diana.wsoft.com.mx/mi_corp/REST/Controller.php?opt=getProfilePromotoria`, {
      method: "POST",
      mode: "cors",
      body: JSON.stringify({
        id_login: usuario.id_usuario,
        promotor:id,
      }),
    })
    .then(res => res.json())
    .then((res) => {
      updateState({ loadingData: false });
      setDataPromotoria(res)
      console.log(res)
    })
  }
  //FORMATO EN NÚMEROS
  function number_format(number, decimals, decPoint, thousandsSep) {
    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''
    var toFixedFix = function (n, prec) {
      var k = Math.pow(10, prec)
      return '' + (Math.round(n * k) / k)
        .toFixed(prec)
    }
    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
      s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
      s[1] = s[1] || ''
      s[1] += new Array(prec - s[1].length + 1).join('0')
    }
    return s.join(dec)
  }
}
